import * as React from 'react';

// eslint-disable-next-line jsx-a11y/control-has-associated-label
export const InvisibleCell = () => <th className="d-none" />;
